<template>
  <div class="oneTwoWrapper">
    <VHeaderOld></VHeaderOld>
    <div class="contentBody" :class="{'suitIOS':!ISANDROID}">
      <div class="mainWrapperOld" ref="mainRef2">
        <div class="content" ref="contentRef">
          <p class="title">{{dTitle}}</p>
          <p class="fTitle"><span class="dfrom">{{dFrom}}</span><span class="depart">{{depart}}</span><span
              class="dtime">{{dTime}}</span></p>
          <div class="dContent" v-for="(item,index) in Dontent" :key="index">
            {{item}}
          </div>
          <div class="imageWrapper">
            <div class="imageContent">
              <img class="img" :src="imgUrl" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import axios from "axios";
  import BScroll from "better-scroll";
  import bgImg from "@/assets/images/pic_workflow.jpg";
  import VHeaderOld from "@/components/VHeaderOld";
  export default {
    name: "Two",
    data() {
      return {
        dTitle: "新工作流上线啦",
        dFrom: "移动办公项目组",
        depart: "",
        dTime: "2018-6-8 12:30",
        Dontent: [
          "全新移动工作流上线啦，大声告诉你，你们心心念念的【我提交的工作流】在移动端终于可见啦。",
          "全新的待办列表，流程节点清晰可见，全新的交互操作，一个字，就是快。",
          "另外，搜索中心了解一下？！输入文本搜，设置条件搜，不想打字？换个姿势，开口说就好了！ 赶快来体验吧 "
        ],
        imgUrl: bgImg
      };
    },
    created() { },
    mounted() {
      setTimeout(() => {
        this._initialScroll();
      }, 500)
    },
    methods: {
      _initialScroll() {
        if (!this.mainWrapper) {
          this.mainWrapper = new BScroll(this.$refs.mainRef2, {
            click: true
          });
        } else {
          this.mainWrapper.refresh();
        }
      }
    },
    components: {
      VHeaderOld
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/Two.vue